import { render, staticRenderFns } from "./CuentaForm.vue?vue&type=template&id=29e94c7a&scoped=true"
import script from "./CuentaForm.vue?vue&type=script&lang=js"
export * from "./CuentaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e94c7a",
  null
  
)

export default component.exports